import { render } from "./CustomFieldsEmptyState.vue?vue&type=template&id=489c4a28&scoped=true"
import script from "./CustomFieldsEmptyState.vue?vue&type=script&lang=js"
export * from "./CustomFieldsEmptyState.vue?vue&type=script&lang=js"

import "./CustomFieldsEmptyState.vue?vue&type=style&index=0&id=489c4a28&lang=scss&scoped=true"
import "./CustomFieldsEmptyState.vue?vue&type=style&index=1&id=489c4a28&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489c4a28"]])

export default __exports__